export const directions = {
    horizontal: 'horizontal',
    vertical: 'vertical',
};
export const skins = {
    light: 'light',
    dark: 'dark',
    standard: 'standard',
    warning: 'warning',
    destructive: 'destructive',
    success: 'success',
    premium: 'premium',
};
//# sourceMappingURL=constants.js.map